<template>
  <form autocomplete="off">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>{{ formIcon }}</md-icon>
        </div>
        <h4 class="title">{{ title }}</h4>
      </md-card-header>

      <md-card-content>
        <ValidationProvider
          name="name"
          rules="required|min:2"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Naam</label>
            <md-input v-model="name" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="order"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Volgorde</label>
            <md-select
              v-model="order"
              name="order"
              id="order"
              required
              :disabled="requesting"
            >
              <md-option
                v-for="(orderOption, index) in [
                  1,
                  2,
                  3,
                  4,
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12,
                  13,
                  14,
                  15,
                  16,
                  17,
                  18,
                  19,
                  20,
                  21,
                  22,
                  23,
                  24,
                  25,
                  26,
                  27,
                  28,
                  29,
                  30,
                  31,
                  32,
                  33,
                  34,
                  35,
                  36,
                  37,
                  38,
                  39,
                  40,
                  41,
                  42,
                  43,
                  44,
                  45,
                  46,
                  47,
                  48,
                  49,
                  50,
                  51,
                  52,
                  53,
                  54,
                  55,
                  56,
                  57,
                  58,
                  59,
                  60,
                  61,
                  62,
                  63,
                  64,
                  65,
                  66,
                  67,
                  68,
                  69,
                  70,
                  71,
                  72,
                  73,
                  74,
                  75,
                  76,
                  77,
                  78,
                  79,
                  80,
                  81,
                  82,
                  83,
                  84,
                  85,
                  86,
                  87,
                  88,
                  89,
                  90,
                  91,
                  92,
                  93,
                  94,
                  95,
                  96,
                  97,
                  98,
                  99
                ]"
                :value="orderOption"
                :key="index"
                >{{ orderOption }}</md-option
              >
            </md-select>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>
      </md-card-content>

      <md-card-actions>
        <md-button
          native-type="button"
          @click.native.prevent="goBack"
          v-bind:class="{
            'md-primary': !formTouched,
            'md-warning': formTouched
          }"
          >Terug</md-button
        >
        <md-button
          :disabled="!formTouched"
          native-type="submit"
          @click.native.prevent="validate"
          class="md-success"
          >Opslaan</md-button
        >
      </md-card-actions>
    </md-card>
    <md-card v-if="this.$route.params.id">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>{{ formIcon2 }}</md-icon>
        </div>
        <h4 class="title">Dienst aan routes koppelen</h4>
      </md-card-header>

      <md-card-content>
        <template v-for="(route, routeIndex) in routes">
          <md-field :key="routeIndex + 'input'">
            <div class="md-layout-item md-inline-checkboxes">
              <md-checkbox
                v-model="selectedRoutes[routeIndex]"
                @change="updateShiftRoute(routeIndex)"
                :disabled="requesting"
                >{{ route.name }}</md-checkbox
              >
            </div>
          </md-field>

          <ValidationProvider
            :key="routeIndex"
            v-if="selectedRoutes[routeIndex]"
            name="Dienst naam"
            :rules="{
              required: false,
              min: 3
            }"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Dienst naam</label>
              <md-input
                v-model="route.shiftName"
                @change="updateShiftRoute(routeIndex)"
                type="text"
              >
              </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </template>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import swal from "sweetalert2";
export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      boolean: null,
      requesting: false,
      name: "",
      order: "",
      routes: [],
      selectedRoutes: {},
      touched: {
        name: false,
        order: false
      },
      submitErrors: ""
    };
  },
  methods: {
    init() {
      if (this.$route.params.id !== undefined) {
        this.loadShift(this.$route.params.id);

        setTimeout(() => {
          this.loadRoutes(this.$route.params.id);
        }, 500);
      } else {
        this.name = "";
        this.order = "";
        setTimeout(this.resetTouched, 100);
      }
    },
    validate() {
      this.$http
        .post(
          this.$apiBaseUrl +
            "shifts/" +
            (this.$route.params.id !== undefined ? this.$route.params.id : ""),
          Object.assign({
            name: this.name,
            order: this.order
          })
        )
        .then(
          response => {
            setTimeout(this.resetTouched, 100);
            this.notifyVue(
              "Dienst succesvol opgeslagen",
              "check",
              "success",
              5000
            );

            if (this.$route.params.id === undefined) {
              this.$router.go(-1);
            }
          },
          response => {
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan dienst",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    updateShiftRoute(routeIndex) {
      console.log(routeIndex, this.selectedRoutes[routeIndex]);

      if (this.selectedRoutes[routeIndex]) {
        this.attachShiftRoute(routeIndex);
      } else {
        this.detachShiftRoute(routeIndex);
      }
    },
    attachShiftRoute(routeIndex) {
      this.$http
        .post(
          this.$apiBaseUrl +
            "shifts/" +
            this.$route.params.id +
            "/route/" +
            this.routes[routeIndex].id,
          Object.assign({
            name: this.routes[routeIndex].shiftName
          })
        )
        .then(
          response => {
            setTimeout(this.resetTouched, 100);
            this.notifyVue(
              'Dienst succesvol aan route "' +
                this.routes[routeIndex].name +
                '" gekoppeld / of dienstnaam aangepast',
              "check",
              "success",
              5000
            );

            if (this.$route.params.id === undefined) {
              this.$router.go(-1);
            }
          },
          response => {
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens koppelen dienst aan route",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    detachShiftRoute(routeIndex) {
      this.$http
        .delete(
          this.$apiBaseUrl +
            "shifts/" +
            this.$route.params.id +
            "/route/" +
            this.routes[routeIndex].id,
          Object.assign({})
        )
        .then(
          response => {
            setTimeout(this.resetTouched, 100);
            this.notifyVue(
              'Dienst succesvol van route "' +
                this.routes[routeIndex].name +
                '" losgekoppeld',
              "check",
              "success",
              5000
            );

            if (this.$route.params.id === undefined) {
              this.$router.go(-1);
            }
          },
          response => {
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger");
            } else {
              this.notifyVue(
                "Onbekende fout tijdens loskoppelen dienst aan route",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    goBack() {
      if (!this.formTouched) {
        this.$router.go(-1);
        return;
      }

      this.showSwal();
    },
    loadShift(id) {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "shifts/" + id).then(
        response => {
          this.name = response.data.shift.name;
          this.order = response.data.shift.order;

          setTimeout(this.resetTouched, 100);

          this.requesting = false;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van diensten", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadShiftRoutes(id, routes) {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "shifts/" + id + "/routes").then(
        response => {
          for (var i in routes) {
            for (var j in response.data.routes) {
              if (routes[i].id != response.data.routes[j].id) {
                continue;
              }
              routes[i].shiftName = response.data.routes[j].pivot.name;
              this.selectedRoutes[i] = true;
            }
          }

          this.routes = routes;

          this.requesting = false;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van diensten", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadRoutes(id) {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "routes").then(
        response => {
          this.selectedRoutes = [];
          for (var i in response.data.routes) {
            this.selectedRoutes[i] = false;
            response.data.routes[i].shiftName = this.name;
          }

          this.loadShiftRoutes(id, response.data.routes);

          // this.requesting = false;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van diensten", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    handleRoutes(routeId) {},
    resetTouched() {
      this.touched.name = false;
      this.touched.order = false;
    },
    showSwal() {
      swal
        .fire({
          title: "Waarschuwing!",
          text: "Weet u zeker dat u de wijzigingen wilt negeren?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Ja, ga terug zonder op te slaan",
          cancelButtonText: "Annuleren",
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$router.go(-1);
          } else if (result.dismiss === swal.DismissReason.cancel) {
          }
        });
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    inArray(haystack, needle) {
      for (var i in haystack) {
        if (haystack[i] === needle) {
          return true;
        }
      }

      return false;
    }
  },
  watch: {
    name() {
      if (!this.requesting) {
        this.touched.name = true;
      }
    },
    order() {
      if (!this.requesting) {
        this.touched.order = true;
      }
    },
    $route(to, from) {
      this.init();
    }
  },
  computed: {
    title: function() {
      if (this.$route.params.id !== undefined) {
        return "Dienst bewerken";
      }
      return "Dienst toevoegen";
    },
    formIcon: function() {
      if (this.requesting) {
        return "hourglass_empty";
      }
      if (this.$route.params.id !== undefined) {
        return "departure_board";
      }
      return "departure_board";
    },
    formIcon2: function() {
      if (this.requesting) {
        return "hourglass_empty";
      }
      if (this.$route.params.id !== undefined) {
        return "directions_bus";
      }
      return "directions_bus";
    },
    formTouched: function() {
      for (var i in this.touched) {
        if (this.touched[i]) {
          return true;
        }
      }

      return false;
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}
</style>
